import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const PointsRanksSection = ({ user, ranks, onOpenInfoModal, t }) => {
    if (!user || user.UserType.Id === 1) return null;

    const ListOfBackgroundColor = [
        "linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%)",
        "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
        "linear-gradient(135deg, #fdf2f8 0%, #fce7f3 100%)"
    ];

    let rate = 100;
    if (user.UserType.Id === 3 || user.UserType.Id === 4) {
        rate = 1000;
    }

    const hasPoints = user.Point && user.Point.length > 0;

    return (
        <div className="profile-ranks-container-card mt-4">
            {/* Header Section */}
            <div className="ranks-header-banner p-4 text-center">
                <div className="d-inline-flex align-items-center justify-content-center gap-3 bg-white-10 backdrop-blur px-4 py-2 rounded-pill border-white-15">
                    <i className="fad fa-trophy-alt text-amber display-6"></i>
                    <h3 className="ranks-banner-title mb-0">
                        {t('Pages.Home.PositionAndPoint')}
                    </h3>
                    <button
                        type="button"
                        onClick={onOpenInfoModal}
                        className="ranks-info-btn"
                        title={t('Pages.Profile.point')}
                    >
                        <i className="fad fa-question-circle"></i>
                    </button>
                </div>
            </div>

            {/* Monthly Points Grid */}
            {hasPoints && (
                <div className="ranks-cards-body p-4">
                    <div className="row g-3 justify-content-center">
                        {user.Point.map(item => {
                            let index = -1;
                            const startIndex = 4;

                            if (ranks && ranks.ranks && ranks.ranks.Point) {
                                const currentRank = ranks.ranks.Point.find(p => p.Month === item.Month && p.Year === item.Year);

                                if (user.UserType.Id === 5 && currentRank && currentRank.MostStudentsHavePoints) {
                                    if (currentRank.MostStudentsHavePoints.some(p => p.UserId === user.Id)) {
                                        index = currentRank.MostStudentsHavePoints.findIndex(p => p.UserId === user.Id);
                                    }
                                } else if ((user.UserType.Id === 3 || user.UserType.Id === 4) && currentRank && currentRank.MostSchoolsHavePoints) {
                                    if (user.School && currentRank.MostSchoolsHavePoints.some(p => p.SchoolId === user.School.Id)) {
                                        index = currentRank.MostSchoolsHavePoints.findIndex(p => p.SchoolId === user.School.Id);
                                    }
                                } else if ((user.UserType.Id === 2 || user.UserType.Id === 6) && currentRank && currentRank.MostUsersHavePoints) {
                                    if (currentRank.MostUsersHavePoints.some(p => p.UserId === user.Id)) {
                                        index = currentRank.MostUsersHavePoints.findIndex(p => p.UserId === user.Id);
                                    }
                                }
                            }

                            const cardBg = index > -1 && index < ListOfBackgroundColor.length
                                ? ListOfBackgroundColor[index]
                                : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";

                            return (
                                <div
                                    className="col-12 col-sm-6 col-md-4 col-lg-3 my-2"
                                    key={`PointMonthly${item.Year}-${item.Month}`}
                                >
                                    <div className="profile-point-card h-100 pos-rel">
                                        <div
                                            className="point-card-inner p-4 text-center rounded-2xl shadow-sm h-100 pos-rel"
                                            style={{ background: cardBg }}
                                        >
                                            {/* Ribbon Tag */}
                                            <div className="point-month-ribbon" title={t('Pages.Home.PointMonthly')}>
                                                <i className="fal fa-calendar-alt ml-1"></i>
                                                {`${item.Year}-${item.Month}`}
                                            </div>

                                            {/* Rank Badge Image */}
                                            {index > -1 && index <= 5 && (
                                                <div className="point-rank-badge-overlay">
                                                    <LazyLoadImage
                                                        src={`/assets/images/archive/sa${startIndex + index}.png`}
                                                        alt={t("Pages.Home.Position")}
                                                        className="rank-badge-img"
                                                    />
                                                </div>
                                            )}

                                            {/* Point Value */}
                                            <div className="point-value-box mt-3">
                                                <span className="point-number-display">{Math.round(item.Point * rate)}</span>
                                                <span className="point-label-subtitle">{t('Pages.Home.Point') || 'نقطة'}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </div>
    );
};

export default PointsRanksSection;
